<template>
    <div>
        <CreateUserRole/>
    </div>
</template>

<script>
import CreateUserRole from '../components/CreateUserRole.vue';
export default {
    components: {
    CreateUserRole
    }
};
</script>